export const MEMBER_PROVIDERS_LINK =
  "https://kells.memberproviders.com/providers/dentists";
